import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import { Typography, useMediaQuery } from "@mui/material";
interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
  variant?: "default" | "bottom";
}
function CustomDrawer({ open, onClose, children, title, variant = "default" }: DrawerProps) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isBottomDrawer = variant === "bottom" && isMobile;
  
  return (
    <Drawer
      // PaperProps={{
      //   sx: {
      //     minWidth: 600,
      //   },
      // }}
      anchor={isBottomDrawer ? "bottom" : "right"}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: isBottomDrawer ? {
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          maxHeight: "85vh",
          minHeight: "auto",
          width: "100%",
          boxShadow: "0 -8px 32px rgba(0, 0, 0, 0.12)",
        } : isMobile ? {
          width: "100vw",
          maxWidth: "100vw",
          height: "100vh",
          maxHeight: "100vh",
        } : {
          minWidth: 600,
        }
      }}
    >
      {isBottomDrawer && (
        <div
          style={{
            width: "40px",
            height: "4px",
            backgroundColor: "#e5e7eb",
            borderRadius: "2px",
            margin: "12px auto 8px",
            flexShrink: 0,
          }}
        />
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: isBottomDrawer ? "0" : "5%",
          padding: isBottomDrawer ? "16px 24px 8px" : "20px",
          borderBottom: isBottomDrawer ? "1px solid #f3f4f6" : "none",
          marginBottom: isBottomDrawer ? "0" : "0",
        }}
      >
        <Typography 
          sx={{ 
            color: "#111827", 
            fontSize: isBottomDrawer ? "24px" : "22px",
            fontWeight: "700",
          }} 
          variant="h5"
        >
          {title}
        </Typography>
        <CloseIcon 
          onClick={onClose}
          sx={{
            cursor: "pointer",
            color: "#6b7280",
            fontSize: "24px",
            "&:hover": {
              color: "#111827",
            }
          }}
        />
      </div>
      <div style={{ 
        flex: 1,
        overflowY: "auto",
        padding: isBottomDrawer ? "0" : "0"
      }}>
        {children}
      </div>
    </Drawer>
  );
}

export default CustomDrawer;
